// import { useContext, useEffect, useMemo, useState } from "react";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";
// import { useNavigate } from "react-router-dom";

// import {
//     FaGift,
//     FaCoins,
//     FaStar,
//     FaTags,
//     FaArrowLeft,
//     FaArrowRight,
//     FaSpinner,
// } from "react-icons/fa";

// import { axiosGet } from "../../../Apis/axiosMethods";
// import { ConfigContext } from "../../../Context/ConfigContext";

// import "./UpcomingRedeemOffer.css";

// const UPCOMING_POINTS_PERCENTAGE = 30;

// const DESKTOP_MIN_WIDTH = 1024;
// const TABLET_MIN_WIDTH = 640;

// const responsive = {
//     desktop: {
//         breakpoint: {
//             max: 3000,
//             min: DESKTOP_MIN_WIDTH,
//         },
//         items: 3,
//         slidesToSlide: 1,
//     },
//     tablet: {
//         breakpoint: {
//             max: DESKTOP_MIN_WIDTH - 1,
//             min: TABLET_MIN_WIDTH,
//         },
//         items: 2,
//         slidesToSlide: 1,
//     },
//     mobile: {
//         breakpoint: {
//             max: TABLET_MIN_WIDTH - 1,
//             min: 0,
//         },
//         items: 1,
//         slidesToSlide: 1,
//     },
// };

// const CustomLeftArrow = ({ onClick, hidden, ...rest }) => {
//     const totalItems = rest?.carouselState?.totalItems || 0;

//     if (hidden || totalItems <= 1) {
//         return null;
//     }

//     return (
//         <button
//             type="button"
//             className="upcoming-carousel-arrow upcoming-carousel-arrow-left"
//             onClick={onClick}
//             aria-label="Previous reward"
//         >
//             <FaArrowLeft />
//         </button>
//     );
// };

// const CustomRightArrow = ({ onClick, hidden, ...rest }) => {
//     const totalItems = rest?.carouselState?.totalItems || 0;

//     if (hidden || totalItems <= 1) {
//         return null;
//     }

//     return (
//         <button
//             type="button"
//             className="upcoming-carousel-arrow upcoming-carousel-arrow-right"
//             onClick={onClick}
//             aria-label="Next reward"
//         >
//             <FaArrowRight />
//         </button>
//     );
// };

// const RewardImage = ({ imageUrl, title }) => {
//     const [imageLoaded, setImageLoaded] = useState(false);
//     const [imageError, setImageError] = useState(false);

//     useEffect(() => {
//         setImageLoaded(false);
//         setImageError(false);
//     }, [imageUrl]);

//     if (!imageUrl || imageError) {
//         return (
//             <div className="upcoming-product-placeholder">
//                 <FaGift />
//             </div>
//         );
//     }

//     return (
//         <>
//             {!imageLoaded && (
//                 <div className="upcoming-product-placeholder">
//                     <FaSpinner className="upcoming-image-spinner" />
//                 </div>
//             )}

//             <img
//                 src={imageUrl}
//                 alt={title}
//                 className="upcoming-redeem-product-image"
//                 loading="eager"
//                 decoding="async"
//                 onLoad={() => setImageLoaded(true)}
//                 onError={() => setImageError(true)}
//                 style={{
//                     display: imageLoaded ? "block" : "none",
//                 }}
//             />
//         </>
//     );
// };

// const UpcomingRedeemOffer = () => {
//     const { business_id } = useContext(ConfigContext);
//     const navigate = useNavigate();

//     const [offers, setOffers] = useState([]);
//     const [businessInfo, setBusinessInfo] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [itemsPerView, setItemsPerView] = useState(3);

//     // Responsive carousel items
//     useEffect(() => {
//         const updateItemsPerView = () => {
//             const width = window.innerWidth;

//             if (width >= DESKTOP_MIN_WIDTH) {
//                 setItemsPerView(3);
//             } else if (width >= TABLET_MIN_WIDTH) {
//                 setItemsPerView(2);
//             } else {
//                 setItemsPerView(1);
//             }
//         };

//         updateItemsPerView();

//         window.addEventListener("resize", updateItemsPerView);

//         return () => {
//             window.removeEventListener("resize", updateItemsPerView);
//         };
//     }, []);

//     // Fetch offers and business information
//     useEffect(() => {
//         let mounted = true;

//         const loadData = async () => {
//             setLoading(true);

//             try {
//                 const [offerResponse, businessResponse] = await Promise.all([
//                     axiosGet("/Users/GetOfferList"),
//                     business_id
//                         ? axiosGet("/Users/GetBusinessInfo", { business_id })
//                         : Promise.resolve(null),
//                 ]);

//                 if (!mounted) {
//                     return;
//                 }

//                 if (offerResponse?.data?.success) {
//                     const activeOffers = (
//                         offerResponse?.data?.data || []
//                     ).filter(
//                         (offer) =>
//                             Number(offer.business_redeem_offer_delete) !== 1
//                     );

//                     setOffers(activeOffers);
//                 } else {
//                     setOffers([]);
//                 }

//                 if (businessResponse?.data?.success) {
//                     setBusinessInfo(
//                         businessResponse?.data?.data?.[0] || {}
//                     );
//                 } else {
//                     setBusinessInfo({});
//                 }
//             } catch (error) {
//                 console.error("Get redeem offers error:", error);

//                 if (mounted) {
//                     setOffers([]);
//                     setBusinessInfo({});
//                 }
//             } finally {
//                 if (mounted) {
//                     setLoading(false);
//                 }
//             }
//         };

//         loadData();

//         return () => {
//             mounted = false;
//         };
//     }, [business_id]);

//     const currentPoints = Math.max(
//         Number(businessInfo?.business_reward_points_balance) || 0,
//         0
//     );

//     const maxUpcomingPoints = Math.floor(
//         currentPoints * (1 + UPCOMING_POINTS_PERCENTAGE / 100)
//     );

//     // Filter and sort upcoming offers
//     const upcomingOffers = useMemo(() => {
//         return offers
//             .filter((offer) => {
//                 const requiredPoints = Number(
//                     offer.business_redeem_offer_points
//                 );

//                 return (
//                     Number.isFinite(requiredPoints) &&
//                     requiredPoints > currentPoints &&
//                     requiredPoints <= maxUpcomingPoints
//                 );
//             })
//             .sort(
//                 (a, b) =>
//                     Number(a.business_redeem_offer_points) -
//                     Number(b.business_redeem_offer_points)
//             );
//     }, [offers, currentPoints, maxUpcomingPoints]);

//     // Preload upcoming reward images
//     useEffect(() => {
//         const imageUrls = [
//             ...new Set(
//                 upcomingOffers
//                     .map((offer) =>
//                         offer.business_redeem_offer_image_url?.trim()
//                     )
//                     .filter(Boolean)
//             ),
//         ];

//         const preloadedImages = imageUrls.map((imageUrl) => {
//             const image = new Image();

//             image.decoding = "async";
//             image.src = imageUrl;

//             return image;
//         });

//         return () => {
//             preloadedImages.forEach((image) => {
//                 image.onload = null;
//                 image.onerror = null;
//             });
//         };
//     }, [upcomingOffers]);

//     const formatNumber = (value) => {
//         return Number(value || 0).toLocaleString("en-US");
//     };

//     const showControls = upcomingOffers.length > itemsPerView;

//     if (loading) {
//         return (
//             <div className="container upcoming-redeem-container">
//                 <div className="upcoming-redeem-loading">
//                     <div className="upcoming-loading-icon">
//                         <FaSpinner />
//                     </div>

//                     <h5>Finding Your Next Reward</h5>

//                     <p>
//                         Please wait while we check the latest rewards
//                         for you.
//                     </p>
//                 </div>
//             </div>
//         );
//     }

//     if (
//         Number(businessInfo?.business_reward_points_balance) > 0 &&
//         !upcomingOffers.length
//     ) {
//         return (
//             <div className="container upcoming-redeem-container">
//                 <div className="upcoming-redeem-empty">
//                     <div className="upcoming-empty-icon">
//                         <FaGift />
//                     </div>

//                     <div>
//                         <span className="upcoming-empty-label">
//                             REWARDS
//                         </span>

//                         <h5>No Upcoming Offers Yet</h5>

//                         <p>
//                             Your current points are{" "}
//                             <strong>
//                                 {formatNumber(currentPoints)}
//                             </strong>
//                             . Keep earning points to unlock more rewards.
//                         </p>
//                     </div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <>
//             {Number(businessInfo?.business_reward_points_balance) > 0 && (
//                 <div className="container upcoming-redeem-container">
//                     <section className="upcoming-redeem-section">
//                         <div className="upcoming-redeem-header">
//                             <span className="upcoming-redeem-header-label">
//                                 REWARDS
//                             </span>

//                             <h3 className="upcoming-redeem-header-title">
//                                 Upcoming Rewards
//                             </h3>
//                         </div>

//                         <div className="upcoming-redeem-carousel-wrapper">
//                             <Carousel
//                                 responsive={responsive}
//                                 infinite={showControls}
//                                 arrows={showControls}
//                                 showDots={showControls}
//                                 swipeable
//                                 draggable
//                                 ssr
//                                 keyBoardControl
//                                 autoPlay={false}
//                                 shouldResetAutoplay={false}
//                                 transitionDuration={700}
//                                 customTransition="transform 700ms ease-in-out"
//                                 containerClass="upcoming-redeem-carousel"
//                                 itemClass="upcoming-redeem-carousel-item"
//                                 dotListClass="upcoming-redeem-carousel-dots"
//                                 customLeftArrow={
//                                     <CustomLeftArrow hidden={!showControls} />
//                                 }
//                                 customRightArrow={
//                                     <CustomRightArrow hidden={!showControls} />
//                                 }
//                                 removeArrowOnDeviceType={[]}
//                                 additionalTransfrom={0}
//                             >
//                                 {upcomingOffers.map((offer) => {
//                                     const requiredPoints = Number(
//                                         offer.business_redeem_offer_points || 0
//                                     );

//                                     const pointsNeeded = Math.max(
//                                         requiredPoints - currentPoints,
//                                         0
//                                     );

//                                     const title =
//                                         offer.business_redeem_offer_title?.trim() ||
//                                         "Exclusive Reward";

//                                     const offerTag =
//                                         offer.business_redeem_offer_tag?.trim() ||
//                                         "YOUR NEXT REWARD";

//                                     return (
//                                         <div
//                                             key={
//                                                 offer.business_redeem_offer_id
//                                             }
//                                             className="upcoming-redeem-slide"
//                                         >
//                                             <div className="upcoming-redeem-card">
//                                                 <div className="upcoming-redeem-visual">
//                                                     <div className="visual-label">
//                                                         <FaStar />
//                                                         <span>
//                                                             NEXT REWARD
//                                                         </span>
//                                                     </div>

//                                                     <div className="visual-image-area">
//                                                         <div className="visual-circle visual-circle-one" />
//                                                         <div className="visual-circle visual-circle-two" />

//                                                         <RewardImage
//                                                             imageUrl={
//                                                                 offer.business_redeem_offer_image_url
//                                                             }
//                                                             title={title}
//                                                         />

//                                                         <div className="visual-star visual-star-one">
//                                                             <FaStar />
//                                                         </div>

//                                                         <div className="visual-star visual-star-two">
//                                                             <FaStar />
//                                                         </div>
//                                                     </div>
//                                                 </div>

//                                                 <div className="upcoming-redeem-details-content">
//                                                     <div className="offer-tag">
//                                                         <FaTags />
//                                                         <span>{offerTag}</span>
//                                                     </div>

//                                                     <h2 className="offer-title">
//                                                         {title}
//                                                     </h2>

//                                                     <div className="offer-points-grid">
//                                                         <div className="points-highlight">
//                                                             <div className="points-highlight-icon">
//                                                                 <FaCoins />
//                                                             </div>

//                                                             <div className="points-highlight-content">
//                                                                 <span>
//                                                                     POINTS REQUIRED
//                                                                 </span>

//                                                                 <strong>
//                                                                     {formatNumber(
//                                                                         requiredPoints
//                                                                     )}
//                                                                 </strong>

//                                                                 <small>
//                                                                     points
//                                                                 </small>
//                                                             </div>
//                                                         </div>

//                                                         <div className="points-needed-banner">
//                                                             <div className="points-needed-icon">
//                                                                 <FaCoins />
//                                                             </div>

//                                                             <div className="points-needed-content">
//                                                                 <span>
//                                                                     YOU NEED
//                                                                 </span>

//                                                                 <strong>
//                                                                     {formatNumber(
//                                                                         pointsNeeded
//                                                                     )}
//                                                                 </strong>

//                                                                 <small>
//                                                                     more points
//                                                                 </small>
//                                                             </div>
//                                                         </div>
//                                                     </div>

//                                                     <div className="reward-action-row">
//                                                         <div className="current-points-box">
//                                                             <span>
//                                                                 YOUR POINTS
//                                                             </span>

//                                                             <strong>
//                                                                 {formatNumber(
//                                                                     currentPoints
//                                                                 )}
//                                                             </strong>
//                                                         </div>

//                                                         <button
//                                                             type="button"
//                                                             className="upcoming-redeem-cta"
//                                                             onClick={() =>
//                                                                 navigate(
//                                                                     `/MyAccount/RedeemPointsDetails/${offer.business_redeem_offer_id}`
//                                                                 )
//                                                             }
//                                                         >
//                                                             <FaGift />

//                                                             <span>
//                                                                 View Reward
//                                                             </span>

//                                                             <FaArrowRight />
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </Carousel>
//                         </div>
//                     </section>
//                 </div>
//             )}
//         </>
//     );
// };

// export default UpcomingRedeemOffer;


import { useContext, useEffect, useMemo, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./UpcomingRedeemOffer.css";

import {
    FaGift,
} from "react-icons/fa";

import { axiosGet, axiosPost } from "../../../Apis/axiosMethods";
import { ConfigContext } from "../../../Context/ConfigContext";

// import "./UpcomingRedeemOffer.css";

const UPCOMING_POINTS_PERCENTAGE = 30;

const DESKTOP_MIN_WIDTH = 1024;
const TABLET_MIN_WIDTH = 640;

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 2,
    },
};

const UpcomingRedeemOffer = () => {
    const { business_id, business_user_id } = useContext(ConfigContext);
    const navigate = useNavigate();

    const [offers, setOffers] = useState([]);
    const [businessInfo, setBusinessInfo] = useState({});
    const [loading, setLoading] = useState(true);
    const [itemsPerView, setItemsPerView] = useState(3);

    // Responsive carousel items
    useEffect(() => {
        const updateItemsPerView = () => {
            const width = window.innerWidth;

            if (width >= DESKTOP_MIN_WIDTH) {
                setItemsPerView(3);
            } else if (width >= TABLET_MIN_WIDTH) {
                setItemsPerView(2);
            } else {
                setItemsPerView(1);
            }
        };

        updateItemsPerView();

        window.addEventListener("resize", updateItemsPerView);

        return () => {
            window.removeEventListener("resize", updateItemsPerView);
        };
    }, []);

    // Fetch offers and business information
    useEffect(() => {
        let mounted = true;

        const loadData = async () => {
            setLoading(true);

            try {
                const [offerResponse, businessResponse] = await Promise.all([
                    axiosGet("/Users/GetOfferList"),
                    business_id
                        ? axiosGet("/Users/GetBusinessInfo", { business_id })
                        : Promise.resolve(null),
                ]);

                if (!mounted) {
                    return;
                }

                if (offerResponse?.data?.success) {
                    const activeOffers = (
                        offerResponse?.data?.data || []
                    ).filter(
                        (offer) =>
                            Number(offer.business_redeem_offer_delete) !== 1
                    );

                    setOffers(activeOffers);
                } else {
                    setOffers([]);
                }

                if (businessResponse?.data?.success) {
                    setBusinessInfo(
                        businessResponse?.data?.data?.[0] || {}
                    );
                } else {
                    setBusinessInfo({});
                }
            } catch (error) {
                console.error("Get redeem offers error:", error);

                if (mounted) {
                    setOffers([]);
                    setBusinessInfo({});
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        loadData();

        return () => {
            mounted = false;
        };
    }, [business_id]);

    const currentPoints = Math.max(
        Number(businessInfo?.business_reward_points_balance) || 0,
        0
    );

    const maxUpcomingPoints = Math.floor(
        currentPoints * (1 + UPCOMING_POINTS_PERCENTAGE / 100)
    );

    // Filter and sort upcoming offers
    const upcomingOffers = useMemo(() => {
        return offers
            .filter((offer) => {
                const requiredPoints = Number(
                    offer.business_redeem_offer_points
                );

                return (
                    Number.isFinite(requiredPoints) &&
                    requiredPoints > currentPoints &&
                    requiredPoints <= maxUpcomingPoints
                );
            })
            .sort(
                (a, b) =>
                    Number(a.business_redeem_offer_points) -
                    Number(b.business_redeem_offer_points)
            );
    }, [offers, currentPoints, maxUpcomingPoints]);

    // Preload upcoming reward images
    useEffect(() => {
        const imageUrls = [
            ...new Set(
                upcomingOffers
                    .map((offer) =>
                        offer.business_redeem_offer_image_url?.trim()
                    )
                    .filter(Boolean)
            ),
        ];

        const preloadedImages = imageUrls.map((imageUrl) => {
            const image = new Image();

            image.decoding = "async";
            image.src = imageUrl;

            return image;
        });

        return () => {
            preloadedImages.forEach((image) => {
                image.onload = null;
                image.onerror = null;
            });
        };
    }, [upcomingOffers]);

    if (
        Number(businessInfo?.business_reward_points_balance) > 0 &&
        !upcomingOffers.length
    ) {
        return (
            <div className="container upcoming-redeem-container">
                <div className="upcoming-redeem-empty">
                    <div className="upcoming-empty-icon">
                        <FaGift />
                    </div>

                    <div>
                        <span className="upcoming-empty-label">
                            REWARDS
                        </span>

                        <h5>No Upcoming Offers Yet</h5>

                        <p>
                            Your current points are{" "}
                            <strong>
                                {currentPoints}
                            </strong>
                            . Keep earning points to unlock more rewards.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    const getCategoryClass = (category) => {
        switch (category) {
            case "Gift Cards":
                return "bg-gift-cards";
            case "Travel and Experiences":
                return "bg-travel";
            case "Home Essentials":
                return "bg-home-essentials";
            case "Fashion Accessories":
                return "bg-fashion";
            case "Gaming":
                return "bg-gaming";
            case "Tech and Electronics":
                return "bg-tech";
            default:
                return "bg-secondary";
        }
    };

    const sendRequest = (business_redeem_offer_id) => {

        const res = axiosPost(`/Users/RedeemRequest`, {
            business_id,
            business_user_id,
            business_redeem_offer_id
        })

        if (res.data.success) {
            Swal.fire(
                "🎉 Success",
                `You redeemed ${res.data.points} points`,
                "success"
            );
        } else {
            Swal.fire("Warning", res.data.message, "warning");
        }
    };

    return (
        <>
            {Number(businessInfo?.business_reward_points_balance) > 0 && (
                <div className="container upcoming-redeem-container">
                    <section className="upcoming-redeem-section">
                        <div className="upcoming-redeem-header">
                            <span className="upcoming-redeem-header-label">
                                REWARDS
                            </span>

                            <h3 className="upcoming-redeem-header-title" onClick={() => navigate("/MyAccount/RedeemPoints")}>
                                Upcoming Rewards
                            </h3>
                        </div>

                        <div className="upcoming-redeem-carousel-wrapper">
                            <Carousel
                                responsive={responsive}
                                autoPlay
                                autoPlaySpeed={2500}
                                infinite={upcomingOffers?.length > 5}
                                pauseOnHover
                                swipeable
                                draggable
                                keyBoardControl
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                            >
                                {upcomingOffers?.map((item, index) => {
                                    const requiredPoints = Number(
                                        item?.business_redeem_offer_points || 0
                                    );

                                    const pointsNeeded = Math.max(requiredPoints - currentPoints, 0);
                                    return (
                                        <div
                                            key={item?.business_redeem_offer_id || index}
                                            className="offer-card"
                                        >
                                            <div
                                                className={`position-absolute top-0 end-0 px-3 py-1 text-white fw-semibold ${getCategoryClass(item?.business_redeem_offers_category_name)}`}
                                                style={{
                                                    borderRightBottomRadius: "20px",
                                                    borderBottomLeftRadius: "0px",
                                                    fontSize: "13px",
                                                }}
                                            >
                                                {item?.business_redeem_offers_category_name || "-"}
                                            </div>

                                            <Link
                                                to={`/MyAccount/RedeemPointsDetails/${item?.business_redeem_offer_id}`}
                                            >
                                                <div className="offer-image mt-2">
                                                    <img
                                                        src={item?.business_redeem_offer_image_url}
                                                        alt={item?.business_redeem_offer_title || "Redeem offer"}
                                                        loading={index < 2 ? "eager" : "lazy"}
                                                        decoding="async"
                                                        width="180"
                                                        height="180"
                                                        onError={(e) => {
                                                            e.currentTarget.src = "https://placehold.co/150x150";
                                                        }}
                                                    />
                                                </div>
                                            </Link>

                                            <Link
                                                to={`/MyAccount/RedeemPointsDetails/${item?.business_redeem_offer_id}`}
                                            >
                                                <h6
                                                    className="offer-title"
                                                    title={item?.business_redeem_offer_title}
                                                >
                                                    {item?.business_redeem_offer_title}
                                                </h6>
                                            </Link>

                                            <p className="offer-desc">
                                                {item?.business_redeem_offer_description}
                                            </p>

                                            <div className="d-flex justify-content-between align-items-center w-100 mt-auto">
                                                <span className="font-weight-bold text-dark">
                                                    {item?.business_redeem_offer_points}{" "}
                                                    <small>Pts</small>
                                                </span>

                                                <span className="blinking-text text-primary" style={{ fontWeight: "bold" }}>
                                                    Need {pointsNeeded} more Pts
                                                </span>
                                            </div>

                                            {/* <div className="w-100 mt-auto text-center">
                                                <div className="font-weight-bold text-dark">
                                                    <span style={{ fontSize: "22px", cursor: "pointer" }}>
                                                        {item?.business_redeem_offer_points}
                                                    </span>{" "}
                                                    <small style={{ cursor: "pointer" }}>Points</small>
                                                </div>

                                                <p className="text-muted mb-0 mt-1" style={{ fontSize: "13px", cursor: "pointer" }}>
                                                    Need {pointsNeeded} more points to redeem
                                                </p>
                                            </div> */}

                                        </div>
                                    );
                                })}
                            </Carousel>
                        </div>
                    </section>
                </div>
            )}
        </>
    );
};

export default UpcomingRedeemOffer;
